import React, {useEffect, useState} from 'react'
import {useSpring, animated} from 'react-spring/web.cjs'
import {Box, Grid, Hidden} from '@material-ui/core'
import {useTheme} from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

const calc = (x: number, y: number) => [x - window.innerWidth / 2, y - window.innerHeight / 2]
const trans1 = (x: any | undefined) => `translateX(${-x / 10}px`
const trans2 = (x: any | undefined) => `translateX(${-x / 30}px`
const trans3 = (x: any | undefined) => `translateX(${-x / 60}px`

const One = () => {
  const [el, setEl] = useState<any>()
  useEffect(() => {
    setEl(document.querySelector('.logo'))
  }, [])

  const theme = useTheme()
  const md = useMediaQuery(theme.breakpoints.up('md'))

  const rotate = (x: number, y: number) => {
    let w = window.innerWidth / 2
    let h = window.innerHeight / 2
    let valX = ((x - w) / w) * 10
    let valY = ((y - h) / h) * 10
    if (el) el.setAttribute('style', `transform: perspective(500px) rotateX(${-valY}deg) rotateY(${-valX}deg);`)
  }

  const [propsSpring, set] = useSpring(() => ({xy: [0, 0], config: {mass: 1, tension: 400, friction: 50}}))
  return (
    <Grid
      container
      justify={'center'}
      alignItems={'center'}
      onMouseMove={({clientX: x, clientY: y}) => {
        md && rotate(x, y)
        set({xy: calc(x, y)})
      }}
    >
      <Box className={'parallax_container'}>
        <Hidden smDown>
          <animated.img className={'one_b1'} src={`/img/page1/b1.png`} style={{transform: propsSpring.xy.interpolate(trans1)}} />
          <animated.img className={'one_b2'} src={`/img/page1/b2.png`} style={{transform: propsSpring.xy.interpolate(trans2)}} />
          <animated.img className={'one_b3'} src={`/img/page1/b3.png`} style={{transform: propsSpring.xy.interpolate(trans3)}} />
        </Hidden>
        <Hidden mdUp>
          <img className={'one_b1'} src={`/img/page1/b1.png`} alt={''} />
          <img className={'one_b2'} src={`/img/page1/b2.png`} alt={''} />
          <img className={'one_b3'} src={`/img/page1/b3.png`} alt={''} />
        </Hidden>
      </Box>
      <Grid item xs={11} md={4}>
        <Box className={'animated pulse infinite'} style={{animationDuration: '3s'}}>
          <img className={'logo'} src="/img/logo.png" width={'100%'} height={'auto'} alt="AURA" />
        </Box>
      </Grid>
      <Box position={'absolute'} className={'dscr'}>
        <Box style={{color: '#349ad5', textAlign: 'center', fontWeight: 500, textShadow: '2px 2px 15px rgba(255, 255, 255, 0.2)'}} fontSize={{ xs: 20, md: 32 }}>
          работаем над новым сайтом
        </Box>
        {/* <Hidden smDown>*/}
        {/*  <img src="/img/page1/dscr.png" width={'100%'} height={'auto'} alt="Коммуникационное агенство" />*/}
        {/* </Hidden>*/}
        {/* <Hidden mdUp>*/}
        {/*  <Box style={{color: '#000', fontSize: 14, textAlign: 'center'}}>КОММУНИКАЦИОННОЕ&nbsp;АГЕНСТВО</Box>*/}
        {/* </Hidden>*/}
        {/* <span className={'mailto'}>*/}
        {/*  <a href="mailto:Irina Steshina <isteshina@aura-agency.com>">НАПИСАТЬ НАМ</a>*/}
        {/* </span>*/}
      </Box>
    </Grid>
  )
}
export default One
